<template>
  <div class="ls-leads-choose-pros-view--container">
    <span class="ls-leads-choose-pros-view--heading">
      We found {{ customer_lead_contacts.length }} highly rated
      {{ customer_lead_contacts.length > 1 ? 'pros' : 'pro' }} interested in your job.
    </span>
    <span v-if="customer_lead_contacts.length > 1" class="ls-leads-choose-pros-view--body">
      We recommend sending a quote request to all {{ customer_lead_contacts.length }} pros.
    </span>
    <div class="ls-leads-choose-pros-view--button-wrapper">
      <LsButton
        class="ls-leads-choose-pros-view--button"
        :text="selectedContacts.length <= 1 ? 'request quote' : 'request quotes'"
        track-id="leads_choose_pros_view-continue"
        :loading="onboarding.loadingStatus.isUpdating"
        :disabled="selectedContacts.length === 0"
        @click="requestQuotes"
      />
    </div>
    <div
      v-for="contact in customer_lead_contacts"
      :key="contact.id"
      class="ls-leads-choose-pros-view--card-wrapper"
    >
      <BCheckbox
        v-model="selectedContacts"
        :native-value="contact"
        test-id="ls-checkbox"
        type="is-primary-invert"
      >
        <LsProviderInfoCardMore v-bind="contact" />
      </BCheckbox>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { AUTH__PROCESSING_CUSTOMER_LEADS, ONBOARDING__LEADS_SUBMIT_CONTACTS } from '@/store/types';
import { LsButton } from '@/components/common';
import LsProviderInfoCardMore from '@/components/LsProviderInfoCardMore/LsProviderInfoCardMore.vue';
import _ from 'lodash';

export default {
  name: 'OnboardingLeadsChooseProsView',
  components: {
    LsButton,
    LsProviderInfoCardMore,
  },
  data() {
    return {
      selectedContacts: [],
    };
  },
  computed: {
    ...mapState(['onboarding', 'featureFlags']),
    ...mapGetters([AUTH__PROCESSING_CUSTOMER_LEADS]),
    customer_lead_contacts() {
      return this[AUTH__PROCESSING_CUSTOMER_LEADS].customer_lead_contacts;
    },
  },
  created() {
    this.selectedContacts = _.cloneDeep(this.customer_lead_contacts);
  },
  methods: {
    ...mapActions([ONBOARDING__LEADS_SUBMIT_CONTACTS]),
    requestQuotes() {
      this[ONBOARDING__LEADS_SUBMIT_CONTACTS]({
        contacts: _.map(this.selectedContacts, ({ id }) => {
          return { id };
        }),
      });
    },
  },
};
</script>
<style lang="scss">
.ls-leads-choose-pros-view--container {
  padding: 60px 70px 87px 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .ls-leads-choose-pros-view--heading {
    font-weight: 600;
    font-size: 24px;
    color: $primary;
    text-align: center;
    margin-bottom: 5px;
  }

  .ls-leads-choose-pros-view--body {
    font-size: 16px;
    text-align: center;
    margin-bottom: 30px;
  }
  .ls-leads-choose-pros-view--button-wrapper {
    margin-bottom: 30px;
    > button {
      min-width: 300px;
    }
  }

  .ls-leads-choose-pros-view--card-wrapper {
    border-top: 1px solid $primary-light;
    padding: 10px 0;
    width: 100%;
    > label {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
    }
    &:last-of-type {
      border-bottom: 1px solid $primary-light;
    }
  }
}

@media (max-width: $mobile-max-width) {
  .ls-leads-choose-pros-view--container {
    padding: 0 0 65px 0;

    .ls-leads-choose-pros-view--heading {
      font-size: 20px;
      color: $primary;
      text-align: center;
      margin: 0 0 10px 0;
    }

    .ls-leads-choose-pros-view--body {
      font-size: 14px;
      text-align: center;
      margin-bottom: 20px;
    }

    .ls-leads-choose-pros-view--button-wrapper {
      position: fixed;
      bottom: 0;
      width: 100%;
      margin-bottom: 0px;
      padding: 15px;
      background-color: rgba(255, 255, 255, 0.6);
      box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.25);
      z-index: $z-index-fixed-button;
      > button {
        box-shadow: 0 4px 4px 0 rgba(74, 74, 74, 0.3);
        min-width: 150px;
      }
    }
  }
}
.themed-app {
  .ls-leads-choose-pros-view--container {
    .ls-leads-choose-pros-view--heading {
      color: $theme-color-primary;
    }
    .ls-leads-choose-pros-view--card-wrapper {
      border-color: $theme-color-primary-light;
      &:last-of-type {
        border-color: $theme-color-primary-light;
      }
    }
  }

  @media (max-width: $mobile-max-width) {
    .ls-leads-choose-pros-view--container {
      .ls-leads-choose-pros-view--heading {
        color: $theme-color-primary;
      }
    }
  }
}
</style>
